import { ReactElement } from "react";

import Head from "next/head";

import { Link } from "@chakra-ui/next-js";

import { Product } from "@/__generated__/graphql";
import Register from "@/components/Register";
import LoginTwoPanelLayout from "@/layouts/LoginTwoPanelLayout";
import { pathTo } from "@/utils/pathGenerators";

function AIPage() {
  return (
    <>
      <Head>
        <title>Release AI</title>
        <meta content="Release AI" name="description" />
        <link href="/favicon.ico" rel="icon" />
      </Head>
      <Register product={Product.ReleaseAi} />
    </>
  );
}
export default AIPage;

AIPage.getLayout = (page: ReactElement) => {
  return (
    <LoginTwoPanelLayout
      rightPanel="releaseAi"
      secondaryAction={
        <>
          Have an account? <Link href={pathTo("/login", { keepQuery: true })}>Sign in</Link>
        </>
      }
    >
      {page}
    </LoginTwoPanelLayout>
  );
};
